module.exports = __webpack_public_path__ + "static/media/id.9f708fe5.svg";